export default __webpack_public_path__ + "static/media/empty-nodata-state.4283f282.svg";